import styles from './menu.less'; export {styles};
import AbstractMenu from '../shared/menu';
import Links from './menu/links';
import {FlagData} from './menu/flags';
import Icon from './icon';

interface MenuProps {
    flags: FlagData[];
}

interface MenuState {
    currentCategoryIds: string[];
    active: boolean;
    render: boolean;
}

export default class Menu extends AbstractMenu<MenuProps, MenuState> {

    constructor(props) {
        super(props);

        this.state = {
            currentCategoryIds: [],
            active: false,
            render: (document.readyState === 'complete'),
        };

        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onLinksActivate = this.onLinksActivate.bind(this);
        this.onPreviousClick = this.onPreviousClick.bind(this);
    }

    componentDidMount() {
        if (!this.state.render) {
            $j(window).on('load', () => {
                this.setState(Object.assign(this.state, {render: true}))
            });
        }
    }

    onOpen() {
        let loadLinks = this.props.onLoadCatalogLinks();
        if (loadLinks) {
            let updateCatalogLinksAfterLoad = false;

            loadLinks.done(() => {
                if (!updateCatalogLinksAfterLoad) {
                    return;
                }

                this.props.onUpdateCatalogLinks();
            });

            // wait for opening animation to complete
            setTimeout(() => {
                updateCatalogLinksAfterLoad = true;
                this.props.onUpdateCatalogLinks();
            }, 300);
        }

        this.setState(Object.assign(this.state, {
            active: true,
            render: true,
            currentCategoryIds: [],
        }));
    }

    onClose() {
        this.setState(Object.assign(this.state, {active: false}));
    }

    onLinksActivate(links: number[]) {
        let categoryIds = [];
        for (let link of links) {
            categoryIds.push(link);
        }
        this.setState(Object.assign(this.state, {currentCategoryIds: categoryIds}));
    }

    onPreviousClick() {
        this.setState((prevState) => {
            let categoryIds = [];
            for (let link of prevState.currentCategoryIds) {
                categoryIds.push(link);
            }
            categoryIds.shift();
            return Object.assign(this.state, {currentCategoryIds: categoryIds})
        });
    }

    render() {
        $j('body').toggleClass(styles.disableScroll, this.state.active);

        return (
            <>
                {ReactDOM.createPortal(
                    <Icon
                        onClick={this.onOpen}
                    />,
                    $j('#navigation-icon-wrapper')[0]
                )}

                {this.state.render && (
                    <div className={classNames(styles.menu, {[styles.active]: this.state.active})}>
                        <div className={styles.overlay} onClick={this.onClose}>
                            <div className={styles.closeIcon}>
                                <div className={styles.innerIcon}/>
                            </div>
                        </div>

                        <div className={styles.menuItems}>
                            <Links
                                currentCategoryIds={this.state.currentCategoryIds}
                                name={_('Menu')}
                                children={this.props.catalogLinks}
                                otherChildren={this.props.otherLinks}
                                flags={this.props.flags}
                                active={true}
                                onLinksActivate={this.onLinksActivate}
                                onPreviousClick={this.onPreviousClick}
                                level={0}
                            />
                        </div>
                    </div>
                )}
            </>
        );
    }
}
